import { render, staticRenderFns } from "./ClientContacts.vue?vue&type=template&id=722e1c73&"
import script from "./ClientContacts.vue?vue&type=script&lang=js&"
export * from "./ClientContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports